import type { PluginDescription } from "@/shared/plugins/usePlugins";
import defaultPlugins from "@/shared/plugins/defaultPlugins";
import router from "./router";

export default [...defaultPlugins, router] as Array<PluginDescription>;
